import { Grid, Box } from '@mui/material';
import RadioImage from 'components/RadioImage';
import withMediaQuery from 'constants/mediaQuery';
import { useStyles } from 'containers/main/styles';

function RadioImageList({ data, title, handleChange, selectedValue, styles: propStyles, mediaQuery }) {
  const classes = useStyles();

  if (data?.length <= 0) return null;

  return (
    <>
      {title && (
        <Grid
          size={12}
          sx={{
            ...(mediaQuery.isMobile && classes.justifyContentCenter),
            ...(mediaQuery.isMobile && classes.manageDeliveryInner),
          }}
        >
          <Box component="span" sx={{ fontWeight: 700 }}>
            {title}
          </Box>
        </Grid>
      )}
      <Grid container spacing={2} size={12} style={propStyles?.container}>
        {data.map((item, idx) => (
          <Grid size={{ xs: 4, md: 2 }} key={`radio-image-${idx}`}>
            <RadioImage
              imgUrl={item.src}
              inputID={item.imputID}
              inputName={item.imputName}
              value={item.value}
              title={item.title}
              handleChange={handleChange}
              selectedValue={selectedValue}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default withMediaQuery()(RadioImageList);
